import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, FormGroupDirective } from '@angular/forms';

import { Observable } from 'rxjs';

@Component({
    selector: 'vsc-validation-message',
    templateUrl: './validation-message.component.html',
    styleUrls: ['./validation-message.component.scss'],
    standalone: false,
})
export class ValidationMessageComponent implements OnInit {
    @Input() controlName: string;
    @Input() formControl: UntypedFormControl;

    constructor(private readonly formGroup: FormGroupDirective) {}

    ngOnInit(): void {
        this.formControl = this.formGroup.control.get(
            this.controlName,
        ) as UntypedFormControl;
    }

    __getParams(value: any): { value: any } {
        return {
            value,
        };
    }

    isObservable(value: any): boolean {
        return value instanceof Observable;
    }
}
